import { render, staticRenderFns } from "./DoorType.vue?vue&type=template&id=5db27895&scoped=true&"
import script from "./DoorType.vue?vue&type=script&lang=js&"
export * from "./DoorType.vue?vue&type=script&lang=js&"
import style0 from "./DoorType.vue?vue&type=style&index=0&id=5db27895&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db27895",
  null
  
)

export default component.exports